module.exports = "./img/5dbb67dcccc67316daddffda3d0aac24.png";